import { MenuStateX } from '../../types/mfc'
import { pubSub } from './pubSub'
import { customStateWrapper, MENU_STATE } from './state'

type SetMenuStateOptions = { immediate?: boolean }

const setMenuState = customStateWrapper<MenuStateX, SetMenuStateOptions>(
    (_, { immediate = false } = {}) => {
        pubSub.MENU.emit('state', MENU_STATE.menu, immediate)
    },
)((updates) => {
    MENU_STATE.menu = { ...MENU_STATE.menu, ...updates }
})

export const getMenuState = () => MENU_STATE.menu

const defaultMenuState = {
    persist: {
        mute: true,
    },
    id: null,
}

export const setMenuIDState = (id: number) => {
    setMenuState({ id })
}

export const setMenuMuteState = (mute: boolean) => {
    setMenuState({
        persist: {
            ...MENU_STATE.menu.persist,
            mute,
        },
    })
}

export const resetMenuState = () => {
    const { persist } = getMenuState()
    setMenuState({ ...defaultMenuState, persist })
}
